<template>
<div class="main" >
	<div class="banner" ref="info" @click="toBuy">
		<img src="../../images/bannerTPL.jpg" alt="">
	</div>
	<div class="tabs" ref="tabs">
		<div class="tabs-container" :class="{fixed:fixed}">
			<Tabs :value="tabName" @on-click="tabChange">
				<TabPane label="产品介绍" name="info"></TabPane>
				<TabPane label="保障方案" name="case"></TabPane>
				<TabPane label="理赔流程" name="claim"></TabPane>
			</Tabs>
			<div class="tabs-container-form" v-show="fixed">
				<Button type="primary" @click="toBuy">立即购买</Button>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">产品介绍</div>
		<div class="detail-main">
			<div class="detail-main-title">1、保险标的：</div>
			<div class="detail-main-text">
				特种设备，主要有叉车、夹抱车、电梯、压力容器、行吊车、储气罐。
			</div>
			<div class="detail-main-title" ref="case">2、保障范围：</div>
			<div class="detail-main-text">
				①操作人员的过失行为<br />
				②自然灾害和意外事故<br />
				③爆炸、坠落或运行突然故障
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">保障方案</div>
		<div class="detail-main">
			<div class="center">
				<table class="productDetail-table">
					<tbody>
						<tr style="text-align:center;">
							<th style="width: 120px;text-align: center;">方案</th>
							<th style="text-align: center;">价格（元/台）</th>
						</tr>
						<tr class="hoverTr">
							<td>年单</td>
							<td>2280</td>
						</tr>
						<tr class="hoverTr">
							<td>月单</td>
							<td>228</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">批单费率表</div>
		<div class="detail-main">
			<div class="center">
				<table class="productDetail-table">
					<tbody>
						<tr style="text-align:center;">
							<th style="text-align: center;">批单类型</th>
							<th colspan="12" style="text-align: center;">费率</th>
						</tr>
						<tr class="hoverTr">
							<td rowspan="2">年单批单</td>
							<td>一月</td>
							<td>二月</td>
							<td>三月</td>
							<td>四月</td>
							<td>五月</td>
							<td>六月</td>
							<td>七月</td>
							<td>八月</td>
							<td>九月</td>
							<td>十月</td>
							<td>十一月</td>
							<td>十二月</td>
						</tr>
						<tr class="hoverTr">
							<td>10%</td>
							<td>20%</td>
							<td>30%</td>
							<td>40%</td>
							<td>50%</td>
							<td>60%</td>
							<td>70%</td>
							<td>80%</td>
							<td>85%</td>
							<td>90%</td>
							<td>95%</td>
							<td>100%</td>
						</tr>
						<tr class="hoverTr">
							<td>月单批单</td>
							<td colspan="12">7.5元/台/天</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="detail-main-text left pt40" ref="claim"><b>产品条款查看：</b></div>
			<div style="font-size: 14px;text-align: left;padding-left: 20px;">
				<p>
					<a href="/static/pdf/haier/阳光财产保险股份有限公司特种设备第三者责任保险条款.pdf" target="_blank" referrerpolicy="no-referrer">《阳光财产保险股份有限公司特种设备第三者责任保险条款》</a>
				</p>
			</div>
		</div>
	</div>
	<div class="detail">
			<div class="detail-title">理赔流程</div>
			<div class="detail-main">
				<div class="detail-main-text">
					<p>
						第一步，报案：发生事故后48小时内，拨打95510，接到报案后10分钟内电话联系客户，告知被保险人后续理赔处理流程。<br />
						第二步，现场查勘：理赔员在约定的时间内赶到事故现场完成对受损项目的查勘取证，并告知理赔资料清单。<br />
						第三步，资料收集：各仓小微按照要求准备理赔资料，提交给理赔员或公估人。<br />
						第四步，损失核定：沟通损失金额，达成一致赔付意见。<br />
						第五步，支付赔款：赔款支付至被保险人指定账户。
					</p>
				</div>
			</div>
			<br>
			<br>
		</div>
	<TrackNotice companyName="中国公司" />
</div>
</template>
<script>
import { mapState } from 'vuex'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	components:{ TrackNotice },
	mixins:[ track ],
	data () {
		return {
			tabName:'info',
			fixed:false
		}
	},
	watch:{
		info(){
			this.checkLogin()
		}
	},
	computed:{
		...mapState({
			info:state=>state.common.info
		})
	},
	mounted() {
		//2023.8.7增加回溯逻辑
		this.track_is_new = true;
		this.$nextTick(()=>{
			window.addEventListener("scroll",this.handleScroll);
			this.trackInit(); 
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	created(){
	},
	methods:{
		checkLogin(){
			// 检测登录
			if(!this.info.userId){
				if(location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		// 立即购买
		async toBuy() {
			await this.$axios.post('/specialEquipment/centerUser/list.json.all',{
				phone: this.info.phone
			}).then((res) => {
				if(res.code==10000000&&res.data&&res.data.length>0){
					this.stopRecord({
						is_new: true
					}).then(()=>{
						this.$router.push(`/forklift/fillin`)
					})
				} else {
					this.$Modal.error({
						title: '提示',
						content: '投保身份验证失败，您无法投保本产品，请联系业务人员处理后重试。'
					});
				}
			})
		},
		getTimeState(){
			// 获取当前时间
			let timeNow = new Date();
			// 获取当前小时
			let hours = timeNow.getHours();
			// 设置默认文字
			let state= false;
			// 判断当前时间段
			if (hours > 21 && hours <= 24) {
				state= true;
			}
			return state;
		},
		// tab切换
		tabChange(val){
			this.$refs[val].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
			})
		},
		// 定位到伤残费率表位置
		toSC(key) {
			this.$refs[key].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
	  	  		block:    "center"  // 上边框与视窗顶部平齐。默认值
			})
		},
		// 监听滚动
		handleScroll() {
			//获取滚动时的高度
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > this.$refs.tabs.offsetTop) {
				this.fixed=true;
			}else{
				this.fixed=false;
			}
		}
	}
}
</script>
<style scoped lang="less">
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
    .step-contain{
        display: flex;
        justify-content: space-between;
        .step-item{
            width: 26%;
        }

    }
    .step-con {
        margin-bottom: 20px;
    }
    .step-con .ivu-steps-item:last-child{
        flex: 1 !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/forklift/index.vue